export const BLOCK_TYPE_COOKIE_REPORT = 'cookieReport';
